 
import React, {useEffect} from 'react';
import {handleCloseApp} from '../HelperFunctions';
import './../styles/toolbar.scss';
import {tooltip} from './../../../smartpak/tooltip';

const Toolbar = ({pageName}) => {
    useEffect(() => {
        if (pageName !== 'Review') {
            const bridleHelp = document.getElementById('bridle-help');
            tooltip([bridleHelp], {});
        }
    }, [pageName]);

    let titleMessage =
        pageName !== 'Color'
            ? `Make sure a selection is made for all options. If a part is not needed, select “No ${pageName}” to continue.`
            : 'Choose a color to continue.';

    return (
        <div className="toolbar">
            {pageName !== 'Review' ? (
                <a
                    id="bridle-help"
                    href="#"
                    className="tooltipTrigger"
                    title={`Next Button Not Working? ${titleMessage}`}
                >
                    <span className="icon">
                        <span className="sr-only">Help</span>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"></path></svg>
                    </span>
                </a>
            ) : (
                <span>&nbsp;</span>
            )}
            <div className="smartfit-logo">
                <span className="smart">Smart</span>
                <span className="fit">Fit</span>
                <sup className="logo-trademark">&trade;</sup>
            </div>
            <span className="icon close-app" onClick={handleCloseApp}>
                <span className="sr-only">Close App</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"><path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"></path></svg>
            </span>
        </div>
    );
};

export default Toolbar;
